import { Injectable, inject } from '@angular/core';
import { BaseInitAppService } from '@shared/core';
import { Observable, catchError, map, of, switchMap, tap } from 'rxjs';
import { AppInitManagerService } from '../../domain/manager/app-init-manager.service';
import { AppStyleManagerService } from '../../domain/manager/app-style-manager.service';

@Injectable({
    providedIn: 'root',
})
export class InitAppService extends BaseInitAppService {
    private readonly appInitManagerService = inject(AppInitManagerService);
    private readonly appStyleManagerService = inject(AppStyleManagerService);

    public appInitError$ = this.appInitManagerService.appInitError$;
    public appModules$ = this.appInitManagerService.appModules$;
    public appPwaSettings$ = this.appInitManagerService.appPwaSettings$;
    public appType$ = this.appInitManagerService.appType$;

    public initApp(): Observable<void> {
        return of(null).pipe(
            switchMap(() => this.appInitManagerService.loadAppModules()),
            switchMap(() => this.appStyleManagerService.loadAppStyle()),
            switchMap(() => this.appInitManagerService.getRealmAndClient()),
            catchError(() => {
                this.appInitManagerService.setAppInitError();
                return of(null);
            }),
            tap(() => {
                this.isInitializedSubject.next(true);
            }),
            map(() => void 0),
        );
    }
}
